var map = {
	"./allBank.png": "fa60",
	"./bank.png": "7620",
	"./bank1.png": "c113",
	"./books.png": "56a1",
	"./cloud.png": "0e0a",
	"./credit-card.png": "c6fd",
	"./credit-card1.png": "0159",
	"./default_cover.jpg": "73c4",
	"./envelope.png": "9c05",
	"./facebook.png": "5307",
	"./facebook1.png": "6900",
	"./facebook2.png": "87be",
	"./facebook3.png": "103f",
	"./file.png": "71db",
	"./first.png": "660f",
	"./growth.png": "264e",
	"./growth1.png": "b8b5",
	"./heart (1).png": "547d",
	"./heart.png": "fa49",
	"./home.png": "fbf5",
	"./home1.png": "2fce",
	"./linepay.png": "2b4c",
	"./linepay1.png": "e4ec",
	"./linepay2.png": "e6ce",
	"./logo.png": "cf05",
	"./logo_novelrealm.png": "4775",
	"./mastercard.png": "7e5a",
	"./modules.png": "c559",
	"./modules1.png": "8264",
	"./money.png": "875b",
	"./no-avartar.jpg": "b226",
	"./notebook.png": "a927",
	"./notepad.png": "5f63",
	"./omise.png": "862c",
	"./open-book.png": "2aee",
	"./paper.png": "c079",
	"./pay.png": "aa5e",
	"./pay1.png": "f4f2",
	"./phone.png": "3547",
	"./price.png": "ede0",
	"./qrcode.png": "10a6",
	"./qrcode1.png": "0169",
	"./sad (1).png": "9ae1",
	"./sad (2).png": "3513",
	"./scb.png": "b17a",
	"./second.png": "9d8e",
	"./share.png": "75e1",
	"./shopeepay.png": "6ed4",
	"./shopeepay1.png": "028a",
	"./shout.png": "11a2",
	"./star.png": "6c8d",
	"./statistics.png": "7f97",
	"./tax.png": "de84",
	"./tax1.png": "cd4f",
	"./third.png": "a275",
	"./trash.png": "c8e4",
	"./truemoney.png": "b1aa",
	"./truewallet.png": "6981",
	"./visa.png": "4b12",
	"./wallet.png": "0131",
	"./wallet1.png": "f6b0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";